import type { NextPage } from "next";

import type { FAQPage, WithContext } from "schema-dts";

import { getModifiedDate } from "lib/helpers";

import Page from "components/layout/page";
import AIPlusHuman from "components/views/support/ai-plus-human";
import FaqSection from "components/views/support/faqs/faqs";
import GetHelpAndSupport from "components/views/support/get-help-and-support";
import SupportFAQJsonLD from "components/views/support/json-ld";
import MainHero from "components/views/support/main-hero";
import Stats from "components/views/support/stats";

type SupportPageProps = { jsonLd: WithContext<FAQPage> };

const SupportPage: NextPage<SupportPageProps> = ({ jsonLd }) => (
  <Page
    title="Enerflo Support | The Operating System for Residential Solar"
    description="97% satisfaction. Under 1-minute responses. Enerflo's residential solar OS support team covers deal flow, lender integrations, CRM, and install tracking. Chat with Flo or a live specialist Mon–Sat."
  >
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    <MainHero />
    <Stats />
    <AIPlusHuman />
    <GetHelpAndSupport />
    <FaqSection />
  </Page>
);

export default SupportPage;

export function getStaticProps() {
  const jsonLd: WithContext<FAQPage> = {
    ...SupportFAQJsonLD,
    dateModified: getModifiedDate(),
  };

  return {
    props: {
      jsonLd,
    },
  };
}
